var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegramSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20Z",
    fill: "url(#paint0_linear_101_180)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5266 9.8944C7.4422 8.6244 9.38613 7.78707 10.3584 7.3824C13.1354 6.2274 13.7126 6.0266 14.0886 6.02C14.1714 6.0186 14.3564 6.04 14.4762 6.1364C14.5772 6.2184 14.6052 6.3294 14.6184 6.4072C14.6387 6.53735 14.6444 6.66938 14.6352 6.8008C14.4846 8.382 13.8336 12.22 13.5022 13.9904C13.3622 14.7396 13.086 14.9904 12.8188 15.0156C12.2388 15.069 11.7972 14.6318 11.2346 14.263C10.3546 13.6862 9.85739 13.327 9.003 12.764C8.0156 12.1134 8.6558 11.7558 9.2184 11.1714C9.36559 11.0184 11.9244 8.6914 11.9738 8.48C11.98 8.4536 11.9858 8.3552 11.9272 8.3032C11.8686 8.2512 11.7826 8.269 11.7202 8.2832C11.6319 8.3032 10.2259 9.23253 7.5022 11.0712C7.103 11.3452 6.74153 11.4785 6.4178 11.4712C6.0606 11.4634 5.3738 11.2692 4.8632 11.1032C4.237 10.8996 3.7392 10.792 3.7832 10.4464C3.80547 10.2667 4.05327 10.0827 4.5266 9.8944Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_180",
    x1: 10.02,
    y1: 0.02,
    x2: 10.02,
    y2: 19.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramSupport);
export default __webpack_public_path__ + "static/media/telegram_support.2a78f6e58f3de13b8709dae19b51fbcb.svg";
export { ForwardRef as ReactComponent };